import React from 'react'
import LoadingSpinner from '../../Components/LoadingSpinner'
import { ReportHeader, ReportContainer, LoadingContainer, Export } from '../../Components/ReportsComponents'

const ReportTemplate = props =>
  (
    <ReportContainer>
      <ReportHeader>
        <span>{props.title}</span>
        {props.date &&
          <span style={{ opacity: '.5' }}>{`${props.date.initial} - ${props.date.end}`}</span> }
      </ReportHeader>
      {!props.loading ?
        props.children
        :
        <LoadingContainer>
          <LoadingSpinner />
        </LoadingContainer>
      }
      {!props.withOutExcel &&
      <Export detail={props.detail}>
        {props.detail &&
        <span style={{ cursor: 'pointer', marginRight: '10px', color: '#4A90E2' }} onClick={props.onClickDetail}>{props.detailText}</span>
        }
        <span style={{ cursor: 'pointer', marginRight: '10px' }} onClick={props.onClick}>Bajar Excel</span>
      </Export>
      }
    </ReportContainer>
  )

export default ReportTemplate



// WEBPACK FOOTER //
// ./src/Containers/Reports/ReportTemplate.jsx